import { Button } from '@avanta/shared/components/ui/Button';
import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Trans, useTranslation } from 'react-i18next';
import { type SurveyIntroduction } from 'types/surveys';

interface IntroductionCardProps {
  introduction: SurveyIntroduction;
  onStartTest: () => void;
}

export const IntroductionCard = ({
  introduction,
  onStartTest,
}: IntroductionCardProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.WELL_BEING);
  return (
    <Card>
      <div className="flex items-center gap-2 mb-4">
        <h3 className="text-lg font-semibold text-gray-900">{introduction?.title}</h3>
      </div>
      <div className="flex flex-col gap-4">
        <Trans
          i18nKey={introduction?.description}
          components={{ br: <br />, strong: <strong /> }}
        />
      </div>
      <Button size="lg" className="w-full mt-8" onClick={onStartTest}>
        {t('WellBeing.Test.start.cta')}
      </Button>
    </Card>
  );
};
